import React from "react";
import TimePicker from "rc-time-picker";
import moment from "moment";
import styled from "styled-components";
import 'rc-time-picker/assets/index.css';

const TimePickerInput = ({
  showSecond = true,
  className = "",
  label = "",
  val = null,
  handleChange,
  keyToChange,
  extraParams = {},
}) => {
  return (
    <TimePickerViewer>
      {label && <Label className="semibold mb-10">{label}</Label>}
      <TimePicker
        showSecond={showSecond}
        className={`rc-timepicker ${label && "has-label"} ${className}`}
        placeholder="Select Time"
        value={val ? moment(val, "HH:mm:ss") : undefined}
        onChange={(e) => handleChange(keyToChange, e, extraParams)}
      />
    </TimePickerViewer>
  );
};

const TimePickerViewer = styled.div`
  .has-label {
    margin-top: 10px;
  }
`;

const Label = styled.span`
  margin-bottom: 20px;
`;

export default TimePickerInput;
